import { useLocation } from 'react-router-dom';
import { StringHelper, ObjectHelper } from '../helpers';
import { useSearchParams } from './useSearchParams';

type PrefilterParams = {
    id: string | null;
    id_biblioteca: string | null;
    id_colecao: string | null;
    tipo_obra: string | null;
    cr: string | null;
};

export const usePrefiterParams = () => {
    const { search } = useLocation();
    const { clearSearchParams } = useSearchParams();
    const PREFILTERS_STORAGE_KEY = 'pergamum-prefilters';

    const initPrefilters = () => {
        const currentParams = getAll();
        const parsedQuery = new URLSearchParams(search);
        let newParams: PrefilterParams = {
            id: null,
            id_biblioteca: null,
            cr: null,
            id_colecao: null,
            tipo_obra: null,
        };
        if (parsedQuery.has('id'))
            newParams.id = parsedQuery.get('id');
        if (parsedQuery.has('id_biblioteca'))
            newParams.id_biblioteca = StringHelper.getWithCommaAtTheEnd(
                parsedQuery.get('id_biblioteca'),
            );
        if (parsedQuery.has('cr'))
            newParams.cr = parsedQuery.get('cr');
        if (parsedQuery.has('id_colecao'))
            newParams.id_colecao = StringHelper.getWithCommaAtTheEnd(
                parsedQuery.get('id_colecao'),
            );
        if (parsedQuery.has('tipo_obra'))
            newParams.tipo_obra = StringHelper.getWithCommaAtTheEnd(
                parsedQuery.get('tipo_obra'),
            );

        if (
            !ObjectHelper.areAllFieldsNull(newParams) &&
            !ObjectHelper.compareObjects(newParams, currentParams)
        )
            localStorage.setItem(
                PREFILTERS_STORAGE_KEY,
                JSON.stringify(newParams),
            );

        parsedQuery.delete('id');
        parsedQuery.delete('id_biblioteca');
        parsedQuery.delete('cr');
        parsedQuery.delete('id_colecao');
        parsedQuery.delete('tipo_obra');
        clearSearchParams(parsedQuery);
    };

    const getAll = (): PrefilterParams => {
        let params: PrefilterParams = {
            id: null,
            id_biblioteca: null,
            cr: null,
            id_colecao: null,
            tipo_obra: null,
        };
        const fromStorageRaw = localStorage.getItem(PREFILTERS_STORAGE_KEY);
        if (fromStorageRaw)
            params = JSON.parse(fromStorageRaw) as PrefilterParams;
        if(params)
            Object.keys(params).forEach((key) => {
                // @ts-ignore
                if(typeof params[key] === 'string'){
                    // @ts-ignore
                    params[key] = decodeURIComponent(params[key])
                }
            })

        return params;
    };

    const remove = (key: keyof PrefilterParams) => {
        const all = getAll();
        all[key] = null;
        localStorage.setItem(
            PREFILTERS_STORAGE_KEY,
            JSON.stringify(all),
        );
    }

    const clear = () => {
        localStorage.removeItem(PREFILTERS_STORAGE_KEY);
    }

    return { initPrefilters, getAll, remove, clear } as const;
};
